<template>
    <div>
        <el-form :model="form" ref="form" :rules="rules" label-width="100px" style="width: 500px">
            <el-form-item label="登录账号" prop="account_type">
                <el-radio-group v-model="form.account_type">
                    <el-radio label="2">手机</el-radio>
                    <el-radio label="1">邮箱</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-if="form.account_type == 2" label="手机" prop="mobile">
                <el-input v-model="form.mobile" placeholder="请输入手机号码"></el-input>
            </el-form-item>
            <el-form-item v-if="form.account_type == 1" label="邮箱" prop="email">
                <el-input v-model="form.email" placeholder="请输入邮箱地址"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
                <el-input type="password" v-model="form.password" @focus="handlePwdFocus" @blur="handlePwdBlur" placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item label="等级" prop="level_uuid">
                <LevelSelector v-model="form.level_uuid"></LevelSelector>
            </el-form-item>
            <el-form-item label="头像" prop="avatar">
                <Uploader v-model="form.avatar" />
            </el-form-item>
            <el-form-item label="姓名" prop="nick_name">
                <el-input v-model="form.nick_name" placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="sex">
                <el-radio-group v-model="form.sex">
                    <el-radio label="1">男</el-radio>
                    <el-radio label="2">女</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="出生日期" prop="birth">
                <el-date-picker value-format="yyyy-MM-dd" type="date" v-model="form.birth" placeholder="选择日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="职业" prop="job">
                <el-input v-model="form.job" placeholder="请输入职业"></el-input>
            </el-form-item>
            <el-form-item label="城市" prop="address">
                <AreaPicker v-model="form.address" placeholder="请选择城市"></AreaPicker>
            </el-form-item>
            <el-form-item label="兴趣" prop="interest">
                <el-input type="textarea" v-model="form.interest" :rows="3" placeholder="请输入兴趣"></el-input>
            </el-form-item>
            <el-form-item label="收货地址" prop="address_detail">
                <el-input v-model="form.address_detail" placeholder="请输入收获地址"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" style="width: 120px" @click="handleConfirm">确定</el-button>
                <el-button style="width: 120px" @click="$router.back()">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Uploader from "@/components/Uploader";
import AreaPicker from "@/components/AreaPicker";
import { add, edit, detail } from "@/api/member/list";
import LevelSelector from "@/components/LevelSelector";
export default {
    components: { Uploader, AreaPicker, LevelSelector },
    data() {
        return {
            form: {
                user_role: "2",
                account_type: "2",
                nick_name: "",
                mobile: "",
                email: "",
                password: "",
                address: [],
                address_detail: "",
            },
            rules: {
                account_type: [{ required: true, message: "请选择账号类型" }],
                nick_name: [{ required: true, message: "请输入用户名" }],
                mobile: [
                    { required: true, message: "请输入手机号码" },
                    { pattern: /^1[0-9]{10}$/, message: "手机格式不正确", trigger: "blur" },
                ],
                email: [
                    { required: true, message: "请输入邮箱地址" },
                    { pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/, message: "邮箱格式不正确", trigger: "blur" },
                ],
                password: [{ required: true, message: "请输入密码" }],
            },
            uuid: "",
        };
    },
    watch: {
        ["form.account_type"](val) {
            if (val == 2) {
                this.rules.mobile = [{ required: true, message: "请输入手机号码" }];
                this.rules.email = [];
                this.$refs.form.clearValidate("email");
            } else {
                this.rules.email = [{ required: true, message: "请输入邮箱地址" }];
                this.rules.mobile = [];
                this.$refs.form.clearValidate("mobile");
            }
        },
    },
    mounted() {
        this.uuid = this.$route.query.uuid;
        if (this.uuid) {
            this.getDetail();
        }
    },
    methods: {
        handlePwdBlur() {
            if (!this.uuid) return;
            if (!this.form.password) {
                this.form.password = "******";
            }
        },
        handlePwdFocus() {
            if (!this.uuid) return;
            if (this.form.password == "******") {
                this.form.password = "";
            }
        },
        getDetail() {
            detail({ uuid: this.uuid }).then(({ code, result, error }) => {
                if (code === 200) {
                    this.form = {
                        ...(result || {}),
                        address: result.city_id
                            ? [result.country_id, result.province_id, result.city_id]
                            : result.province_id
                            ? [result.country_id, result.province_id]
                            : result.country_id
                            ? [result.country_id]
                            : [],
                        user_role: "2",
                        password: "******",
                    };
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                const params = {
                    ...this.form,
                    country_id: this.form.address[0],
                    province_id: this.form.address[1] ? this.form.address[1] : null,
                    city_id: this.form.address[2] ? this.form.address[2] : null,
                    password: this.form.password === "******" ? "" : this.form.password,
                };
                delete params.address;
                if (this.uuid) {
                    params.uuid = this.uuid;
                    edit(params).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("编辑成功");
                            this.$router.back();
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                } else {
                    add(params).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("新增成功");
                            this.$router.back();
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                }
            });
        },
    },
};
</script>

<style></style>
